"use client";

import { CommandIcon } from "./command-icon";
import { useCommandPanel } from "./command-panel-provider";

export function CommandPanelTrigger() {
    const { toggle } = useCommandPanel();

    return (
        <button
            type="button"
            onClick={toggle}
            aria-label="Talk to Command"
            className="command-cta-outline inline-flex h-8 items-center gap-1.5 rounded-full px-3 text-[13px] font-semibold text-primary transition-colors hover:bg-primary/[0.05] md:h-9 md:px-4"
        >
            <CommandIcon className="size-4 shrink-0" />
            <span className="hidden sm:inline">Talk to Command</span>
        </button>
    );
}
